import React, { useEffect, useState } from 'react';
import { authHeaders, getStoredUser } from '../../services/auth';
import { TCAcceptanceModal } from './TCAcceptanceModal';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Renders children always; overlays a blocking T&C modal if the user has not
 * yet accepted the current T&C version. The modal occupies a fixed full-screen
 * z-index and prevents interaction with anything underneath.
 */
export const TCGate = ({ children }) => {
  const [needsAcceptance, setNeedsAcceptance] = useState(false);
  const [checked, setChecked] = useState(false);
  const user = getStoredUser();

  useEffect(() => {
    let cancelled = false;
    if (!user) { setChecked(true); return; }
    // Super admins are platform operators and don't need to accept the
    // community-facing T&C. They edit it via the SA dashboard.
    if (user.role === 'super_admin') { setChecked(true); return; }
    fetch(`${API}/api/tc/status`, { headers: authHeaders(), credentials: 'include' })
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then((j) => {
        if (cancelled) return;
        setNeedsAcceptance(!j.accepted);
        setChecked(true);
      })
      .catch(() => { if (!cancelled) setChecked(true); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {children}
      {checked && needsAcceptance && (
        <TCAcceptanceModal user={user} onAccepted={() => setNeedsAcceptance(false)} />
      )}
    </>
  );
};

export default TCGate;
